<div class="mb-3 row">

  <!-- Calculator Button -->
  <div *ngIf="calculatorEnabled" class="mb-3 row">
    <div class="row mb-3">
      <div class="col-lg-12 col-md-12 col-sm-12 d-flex justify-content-between">
        <button type="button" class="btn btn-info btn-sm" (click)="showCalculator()">
          <i class="fas fa-clone"></i>&nbsp;Calculator
        </button>
      </div>
    </div>
  </div>

  <dx-popup [visible]="visiblePopup"
            [width]="600"
            [height]="700"
            [showTitle]="true"
            title="RMD Calculator"
            [dragEnabled]="true"
            [hideOnOutsideClick]="true"
            [showCloseButton]="true"
            [resizeEnabled]="true"
            [shading]="true"
            shadingColor="rgba(0, 0, 0, 0.5)"
            [position]="{ my: 'center', at: 'center', of: windowRef }"
            (onShown)="onPopupShown()"
            (onHidden)="onPopupHidden()">
    <div *dxTemplate="let data of 'content'">
      <app-rmd-calculator *ngIf="componentReady"
                          #calculator
                          [account]="selectedAccount"
                          [mode]="calculatorMode"
                          [isInherited]="isInherited"
                          [isAdvisorUser]="isAdvisorUser"
                          [canEdit]="canEdit()"
                          (saveToAccountEvent)="onSaveFromCalculator($event)">
      </app-rmd-calculator>
    </div>
    <div *dxTemplate="let toolbar of 'toolbar'">
      <dx-button text="Confirm"
                 type="default"
                 (onClick)="onConfirm()"></dx-button>
      <dx-button text="Cancel"
                 type="danger"
                 (onClick)="onCancel()"></dx-button>
    </div>
  </dx-popup>

  <label class="col-sm-2 col-form-label fw-bold" for="showIRAType">IRA Filter: </label>
  <div class="col-sm-10" id="showIRAType">
    <div class="form-check form-check-inline">
      <input class="form-check-input" type="radio" id="Radio_1"
             name="iraTypeFilter"
             [value]="1"
             [(ngModel)]="selIRAType"
             (ngModelChange)="filterChanged()"
             title="Show Non-inherited IRAs only">
      <label class="form-check-label" for="Radio_1">Non-Inherited</label>
    </div>
    <div class="form-check form-check-inline">
      <input class="form-check-input" type="radio" id="Radio_2"
             name="iraTypeFilter"
             [value]="2"
             [(ngModel)]="selIRAType"
             (ngModelChange)="filterChanged()"
             title="Show Inherited IRAs only">
      <label class="form-check-label" for="Radio_2">Inherited</label>
    </div>
  </div>
</div>

<div class="mb-3 row">
  <label class="col-sm-2 col-form-label fw-bold" for="showRequirementType">Requirement: </label>
  <div class="col-sm-10" id="showRequirementType">
    <div class="form-check form-check-inline">
      <input class="form-check-input" type="radio" id="ReqRadio_1"
             name="requirementFilter"
             [value]="1"
             [(ngModel)]="selRequirement"
             (ngModelChange)="filterChanged()"
             title="Show All Requirements, Met or Unmet">
      <label class="form-check-label" for="ReqRadio_1">All</label>
    </div>
    <div class="form-check form-check-inline">
      <input class="form-check-input" type="radio" id="ReqRadio_2"
             name="requirementFilter"
             [value]="2"
             [(ngModel)]="selRequirement"
             (ngModelChange)="filterChanged()"
             title="Show Unmet Requirements Only">
      <label class="form-check-label" for="ReqRadio_2">Unmet Only</label>
    </div>
    <div class="form-check form-check-inline">
      <input class="form-check-input" type="radio" id="ReqRadio_3"
             name="requirementFilter"
             [value]="3"
             [(ngModel)]="selRequirement"
             (ngModelChange)="filterChanged()"
             title="Show Met Requirements Only">
      <label class="form-check-label" for="ReqRadio_3">Met Only</label>
    </div>
  </div>
</div>

<!-- As Of Date, Cache Date, and Refresh Button (Right Justified) -->
<div class="mb-2 row d-flex justify-content-between align-items-center" *ngIf="isAOUser()">
  <!-- "As Of" on the left -->
  <div class="col-auto">
    <label class="font-weight-bold">As Of:</label>
    <strong [ngClass]="{'fetching-placeholder' : !asOfDate}">
      {{ asOfDate ? asOfDate : 'fetching...' }}
    </strong>
  </div>

  <!-- "Cache Date" & Refresh Button on the right -->
  <div class="col-auto d-flex align-items-center">
    <label class="font-weight-bold me-1">Cache Date:</label>
    <strong [ngClass]="{'fetching-placeholder': !cacheDate}">
      {{ cacheDate ? (cacheDate | date: 'MM/dd/yy hh:mm a') : 'fetching...' }}
    </strong>

    <!-- Refresh Cache Button -->
    <button type="button" class="btn btn-warning btn-sm ms-3" (click)="refreshCache()">
      <i class="fas fa-sync-alt"></i>&nbsp;Refresh Cache
    </button>
  </div>
</div>

<!-- Loading Indicator -->
<div class="text-center m-t-none m-b-none" *ngIf="isInitializing">
  <p>Loading data, please wait...</p>
  <div class="spinner-border text-primary" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>

<!-- Main Content -->
<div class="m-t-none m-b-none" *ngIf="!isInitializing">
  <div class="mb-3 align-items-center row" *ngIf="selIRAType === 1">
    <div class="col-12">
      <div class="grid-scroll-top">
        <dx-data-grid class="dx-data-grid" #dgRmdTracker id="dgRmdTracker"
                      [dataSource]="rmdTrackerNonInheritedDetails"
                      [export]="{ enabled: true }"
                      [height]="'62vh'"
                      [scrolling]="{ mode: 'virtual', useNative: false, showScrollbar: 'always',
                          preloadEnabled: false, }"
                      [paging]="{ enabled: false }"
                      [rowAlternationEnabled]="true"
                      [showBorders]="true"
                      [showColumnLines]="true"
                      [showColumnHeaders]="true"
                      [columnAutoWidth]="false"
                      columnResizingMode="widget"
                      [allowColumnReordering]="false"
                      [allowColumnResizing]="true"
                      [selection]="{ allowSelectAll: false,
                                     mode: 'single' }"
                      [columnChooser]="{ enabled: false,
                                         title: 'Select columns' }"
                      [filterRow]="{ visible: true }"
                      [headerFilter]="{ visible: true }"
                      [searchPanel]="{ visible: false,
                                       width: 200,
                                       placeholder: 'Search...' }"
                      [editing]="{ allowUpdating: true,
                                   allowDeleting: false,
                                   allowAdding: false,
                                   mode: 'cell' }"
                      [wordWrapEnabled]="true"
                      [columns]="gridColumns"
                      (onCellPrepared)="oncp($event)"
                      (onCellClick)="openNotesPopup($event)"
                      (onEditorPreparing)="onep($event)"
                      (onRowUpdating)="onUpdate($event)"
                      (onExporting)="onExporting($event)">
          <!-- Custom Cell Template -->
         <div *dxTemplate="let cell of 'colActions'">
            <app-rmd-cell-template [data]="cell.data"
                                   [id]="cell.data.investorId"
                                   [status]="cell.data.investorRmdStatus"
                                   [canEdit]="canEdit()"
                                   (changeStatus)="changeNonInheritedRequirementMetStatus(cell.data, $event)">
            </app-rmd-cell-template>
          </div>
          <!-- Master Detail Template -->
          <dxo-master-detail [enabled]="true" [autoExpandAll]="false" [template]="'detail'">
          </dxo-master-detail>
          <div *dxTemplate="let data of 'detail'">
            <div class="dx-datagrid-perf-detail-indent-caption">Accounts:</div>
            <dx-data-grid class="dx-datagrid-perf-internal-grid grL4Col"
                          [dataSource]="data.data.accounts"
                          keyExpr="accountId"
                          [columnAutoWidth]="false"
                          columnResizingMode="widget"
                          [allowColumnResizing]="true"
                          [rowAlternationEnabled]="false"
                          [showColumnHeaders]="true"
                          [wordWrapEnabled]="true"
                          [width]="'100%'"
                          [scrolling]="{
                          mode: 'standard',
                          showScrollbar: 'always',
                          scrollByContent: true,
                          preloadEnabled: false,
                          useNative: false
                          }"
                          [editing]="{
                          allowUpdating: true,
                          allowDeleting: false,
                          allowAdding: false,
                          mode: 'cell'
                          }"
                          [columns]="accountGridColumns"
                          (onCellPrepared)="oncp($event)"
                          (onEditorPreparing)="onep($event)"
                          (onCellClick)="openNotesPopup($event)"
                          (onRowUpdating)="onru($event)">
              <div *dxTemplate="let cell of 'accountCalcTemplate'">
                <button *ngIf="cell.data.custodianProvidedData == false"
                        class="btn btn-info btn-xs"
                        (click)="showCalculator(cell.data)">
                  <i class="fas fa-calculator"></i> Calc
                </button>
              </div>
            </dx-data-grid>
          </div>
        </dx-data-grid>
      </div>
    </div>
  </div>

  <div class="mb-3 align-items-center row" *ngIf="selIRAType === 2">
    <div class="col-12">
      <dx-data-grid #dgRmdInheritedTracker id="dgRmdInheritedTracker"
                    [dataSource]="rmdTrackerInheritedDetails"
                    [export]="{ enabled: true }"
                    [height]="'62vh'"
                          [scrolling]="{ mode: 'virtual', useNative: false, showScrollbar: 'always',
                          preloadEnabled: false }"
                    [paging]="{ enabled: false }"
                    [rowAlternationEnabled]="true"
                    [showBorders]="true"
                    [showColumnLines]="true"
                    [showColumnHeaders]="true"
                    [columnAutoWidth]="false"
                    columnResizingMode="widget"
                    [allowColumnReordering]="false"
                    [allowColumnResizing]="true"
                    [selection]="{ allowSelectAll: false, mode: 'single' }"
                    [columnChooser]="{ enabled: false, title: 'Select columns' }"
                    [filterRow]="{ visible: true }"
                    [headerFilter]="{ visible: true }"
                    [searchPanel]="{
                    visible: false,
                    width: 200,
                    placeholder: 'Search...'
                  }"
                    [editing]="{
                    allowUpdating: true,
                    allowDeleting: false,
                    allowAdding: false,
                    mode: 'cell'
                  }"
                    [columns]="inheritedGridColumns"
                    (onCellPrepared)="oncp($event)"
                    (onEditorPreparing)="onep($event)"
                    (onRowUpdating)="onru($event, true)"
                    (onCellClick)="openNotesPopup($event)"
                    (onExporting)="onExportingInherited($event)">
        <!-- Custom Cell Template -->
        <div *dxTemplate="let cell of 'colInheritedActions'">
          <app-rmd-cell-template [data]="cell.data"
                                 [id]="cell.data.accountId"
                                 [status]="cell.data.accountRmdStatus"
                                 [canEdit]="canEdit()"
                                 (changeStatus)="changeInheritedRequirementMetStatus(cell.data, $event)">
          </app-rmd-cell-template>
        </div>
        <div *dxTemplate="let cell of 'accountCalcTemplateInh'">
          <button *ngIf="cell.data.custodianProvidedData == false"
                  class="btn btn-info btn-xs"
                  (click)="showCalculator(cell.data, true)">
            <i class="fas fa-calculator"></i> Calc
          </button>
        </div>
      </dx-data-grid>
    </div>
  </div>
</div>
<dx-popup [visible]="visibleNotesPopup"
          [width]="1235"
          [height]="600"
          [showTitle]="true"
          title="Account Notes"
          [dragEnabled]="true"
          [hideOnOutsideClick]="true"
          [showCloseButton]="true"
          [resizeEnabled]="true"
          [shading]="true"
          shadingColor="rgba(0, 0, 0, 0.5)"
          (onHidden)="onNotesPopupHidden()">
  <app-account-notes #accountNotes [accounts]="selectedAccounts"
                     (noteAdded)="onNoteAdded($event)"
                     (noteDeleted)="onNoteDeleted($event[0], $event[1])"></app-account-notes>
</dx-popup>
